import { ACTIONS } from '../common/utils/actions';

const metricsMetadata = {
  total_automations: 90,
  filtered_automations: 2,
  data: [
    {
      automation_name: 'api_changes',
      display_automation_name: 'API Changes',
      automation_id: 2,
      actions: [
        ACTIONS.APPROVE_V1,
        ACTIONS.REQUEST_CHANGES_V1,
        ACTIONS.ADD_LABEL_V1,
        ACTIONS.ADD_COMMENT_V1,
        'explain-code-experts@v1' // Intentionally adding an "unknown" action to to test that we are handling this scenario gracefully
      ],
      automation_path: 'rule-sugggestions-extra-long-file-name.cm',
      repo_name: 'linear-b/gitstream-sls-pipeline',
      file_path: '.cm/rebenu',
      total_run: 40,
      total_run_in_period: 20,
      first_run_time: '2022-10-23T00:00:00.000',
      is_org_level: false,
      total_repos: null,
      active_repos: null,
      roi_data: [
        {
          label: "8 hours lead time saved with 'merge'",
          tooltip: 'Industry average of 8 hours pickup time per PR'
        },
        {
          label: "8 hours lead time saved with 'approve'",
          tooltip: 'Industry average of 8 hours pickup time per PR'
        }
      ]
    },
    {
      automation_name: 'api_changes',
      display_automation_name: 'API Changes',
      automation_id: 3,
      actions: [ACTIONS.ADD_LABEL_V1, ACTIONS.ADD_COMMENT_V1],
      automation_path: 'rebenu.cm',
      repo_name: 'moshe',
      file_path: '.cm/rebenu',
      total_run: 40,
      total_run_in_period: 20,
      first_run_time: '2022-10-23T00:00:00.000',
      is_org_level: true,
      total_repos: 9,
      active_repos: 3,
      roi_data: [
        {
          label: "8 hours lead time saved with 'approve'",
          tooltip: 'Industry average of 8 hours pickup time per PR'
        }
      ]
    },
    {
      automation_name: 'mark_no_tests',
      display_automation_name: 'Mark No Tests',
      automation_id: 4,
      actions: [ACTIONS.MERGE_V1],
      automation_path: 'gitstream.cm',
      repo_name: 'coreos-frontend',
      file_path: '.cm/gitstream.cm',
      total_run: 4431,
      total_run_in_period: 20,
      first_run_time: '2022-05-30T00:00:00.000',
      is_org_level: false,
      roi_data: [
        {
          label: "8 hours lead time saved with 'approve'",
          tooltip: 'Industry average of 8 hours pickup time per PR'
        }
      ]
    },
    {
      automation_name: 'mark_no_tests',
      display_automation_name: 'Mark No Tests',
      automation_id: 5,
      actions: [ACTIONS.ADD_REVIEWERS_V1],
      automation_path: 'gitstream.cm',
      repo_name: 'coreos-frontend',
      file_path: '.cm/gitstream.cm',
      total_run: 4431,
      total_run_in_period: 20,
      first_run_time: '2022-05-30T00:00:00.000',
      is_org_level: true,
      total_repos: 50,
      active_repos: 50,
      roi_data: [
        {
          label: `8 reviewers assigned`,
          tooltip: `Total number of reviewers that were assigned automatically using gitStream rules`
        }
      ]
    },
    {
      automation_name: 'mark_no_tests',
      display_automation_name: 'Mark No Tests',
      automation_id: 6,
      actions: [ACTIONS.ADD_LABELS_V1],
      automation_path: 'gitstream.cm',
      repo_name: 'coreos-frontend',
      file_path: '.cm/gitstream.cm',
      total_run: 45,
      total_run_in_period: 20,
      first_run_time: '2022-05-30T00:00:00.000',
      is_org_level: true,
      total_repos: 50,
      active_repos: 49,
      roi_data: [
        {
          label: "8 hours lead time saved with 'approve'",
          tooltip: 'Industry average of 8 hours pickup time per PR'
        }
      ]
    },
    {
      automation_name: 'mark_no_tests',
      display_automation_name: 'Mark No Tests',
      automation_id: 7,
      actions: [ACTIONS.ADD_REVIEWERS_V1, ACTIONS.ADD_COMMENT_V1],
      automation_path: 'gitstream.cm',
      repo_name: 'coreos-frontend',
      file_path: '.cm/gitstream.cm',
      total_run: 45,
      total_run_in_period: 20,
      first_run_time: '2022-05-30T00:00:00.000',
      is_org_level: true,
      total_repos: 50,
      active_repos: 49,
      roi_data: [
        {
          label: "8 hours lead time saved with 'approve'",
          tooltip: 'Industry average of 8 hours pickup time per PR'
        }
      ]
    }
  ],
  total_roi: {
    quality: {
      label: '32 reviewers assigned',
      value: 32
    },
    time: {
      label: '14 days lead time saved',
      value: 10
    }
  }
};

export default metricsMetadata;
